export default __webpack_public_path__ + "static/media/mouse scroll.8e567866.svg";